import { Splide } from '@splidejs/splide';

/**
 * SlideKnowhow
 * 最新ノウハウの記事カードスライダー。PCは3枚並び、SPは中央1枚＋両隣ちら見。
 * 各スライドはカード全体リンク。アロー操作のみ（ページネーション無し）。
 * 複数インスタンス対応。
 *
 * @example
 * <div class="p-knowhow-slider splide js-slide-knowhow">
 *   <div class="splide__track"><ul class="splide__list">
 *     <li class="splide__slide"><a class="p-knowhow-card" href="…">…</a></li> …
 *   </ul></div>
 * </div>
 */
export default class SlideKnowhow {
  constructor(options = {}) {
    this.selector = options.selector || '.js-slide-knowhow';
    document.querySelectorAll(this.selector).forEach((el) => this.setup(el));
  }

  /**
   * @param {HTMLElement} el
   */
  setup(el) {
    try {
      // モバイルファースト（mediaQuery:'min'）。
      // 既定＝SP（中央1枚＋ちら見）。初期マウントを center 構成にしておくことで
      // loop+center のクローン計算が崩れない（perPageをbreakpointで切替えると中央化が壊れるため）。
      // ≥768（ovsp）で3枚並び・左寄せへ拡張。カード幅は全幅で 27.6rem 固定（デザイン共通）。
      const splide = new Splide(el, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        focus: 'center',
        fixedWidth: '27.6rem',
        gap: '2.4rem',
        arrows: true,
        pagination: false,
        drag: true,
        mediaQuery: 'min',
        breakpoints: {
          768: {
            perPage: 3,
            focus: 0,
            gap: '3.2rem',
          },
        },
      });
      splide.mount();
    } catch (error) {
      console.error('SlideKnowhow: Failed to initialize Splide', error);
    }
  }
}
